import Vue from 'vue';
import breakpointService from './breakpoints.service';

class BreakpointsState {
	breakpointsState: {
		[breakpoint: string]: boolean;
	} = Vue.observable({});

	constructor() {
	    breakpointService.addListener(this.breakpointChangeHandler.bind(this));
	}

	/*
    Supports formats like
    'ls,md'
    'max-md'
    'min-md,max-xl'
    */
	public isBreakpointActive(breakpointsDescriptor: string) {
	    return breakpointService.getExpandedBreakpoints(breakpointsDescriptor).some((bp: any) => this.breakpointsState[bp]);
	}

	public get activeBreakpoint(): string {
	    return Object.keys(this.breakpointsState).find(bp => this.breakpointsState[bp])!;
	}

	breakpointChangeHandler() {
	    breakpointService.getBreakpoints().forEach((bp: any) => {
	        Vue.set(this.breakpointsState, bp.name, breakpointService.isActiveBreakpoint(bp.name));
	    });
	}
}

export default new BreakpointsState();
